import preAxios from '../preAxios';
interface getByCompanyIdAndSignParams {
  companyId: number,
  sign: string
}
class other extends preAxios {
  constructor() {
    super()
  }
  getByCompanyIdAndSign(params: getByCompanyIdAndSignParams): Promise<Object> {
    const that = this;
    return this.$axiosget("/manager/other/getByCompanyIdAndSign", {
      params
    })
  }
}
export default new other


// WEBPACK FOOTER //
// ./src/ts/API/manager/other.ts